import React, { useEffect, useRef, useState } from "react";
import UI from "../DataWithFilter/UI";
import Home from "../Home/Home";
import { useLocation } from "react-router";
import { commonFetchData } from "../../utils/commanFunctions";
import { Header } from "./Header";




const SeeAll = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  // const apiParams = params.get('apiParams') 
  const apiParams = params.get('componentParams')
  const title = params.get("title");
  const type = params.get("type");
  const is_embedded_in_parent = localStorage.getItem("is_embedded_in_parent")
  // const id = params.get('apiParams');

  const [data, setData] = useState([]);
  const [noData, setNoData] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedFilter, setSelectedFilter] = useState({
    display_value: "All",
    query_value: "all",
  });

  const createUrl = ()=>{
    let url = `/planner/places-events/groups/${
      apiParams ? "?" + apiParams : ""
    }`;
    url += url.includes("?") ? "&all=true" : "?all=true";
    return url
  }

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       setIsLoading(true);

  //       const url = createUrl()

  //       const [placesResponse] = await Promise.all([
  //         commonFetchData(url, { req: "get", onErrorData: {} }),
  //       ]);

  //       setData(placesResponse.length > 0 ? placesResponse : []);
  //       setNoData(placesResponse.length === 0);
  //     } catch (error) {
  //       console.error("Data fetching error:", error);
  //       setNoData(true);
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };

  //   // fetchData();
  // }, [apiParams]);

  useEffect(()=>{
if(data.length> 0)
 setNoData(data[0].event_or_place_list?.length=== 0)
  else
setNoData(true)


  },[data])
  return (
    <Home
      nav={"List"}
      showBottomNav={true}
      showPersonalizedButton={false}
      showOldFilter={false}
      // headerData={}
    >
          <Header data={{
        title: title,
        // buttonText: "List",
        // buttonUrl: "/?path=trip",
      }}
          showFilter={false}
          showSearch={false}
          showBookMark={false}
 url={createUrl()}
  setData={setData}
  // setNoData={setNoData}
  setIsLoading={setIsLoading}
  filterType="live"
          />
      <div className={`${noData ?"no-parent-container" : ""} seeAllContainer`}
      style={
       {
            paddingTop:is_embedded_in_parent? "136px":"120px"
       } 
      }>
        <UI
        parentDivClass={`overflow-hidden !static see-all-content`}
          // isFilter={true}
          url={`/planner/places-events/groups/?all=true${
            apiParams ? "&" + apiParams : ""
          }`}
          data={data.length > 0 ? data[0]?.event_or_place_list : []}
          setData={setData}
          isloading={isLoading}
          setIsLoading={setIsLoading}
          noData={noData}
          setNoData={setNoData}
          showHeader={true}
          name={data.length > 0 && data[0]?.name ? (data[0]?.name === title ? title : data[0]?.name) : ""}
          description={data.length > 0 && data[0]?.description ? data[0].description : ""}
          showDescription={true}
        />
      </div>
    </Home>
  );
};

export default SeeAll;
